let pathname = window.location.pathname.substring(1).split('/');

let instance = pathname[0];
let userID = pathname[1];
let productID = pathname[2];

let api = `https://${instance}.api.facilitavendas.com/api/v1/`;

export const facilita = {
	gstoken: '70e735cbf8cd58a1a9327e3f8d17511c',
	gstokenuser:
		'eyJpdiI6IjRhSHVkRGV3QWhFQUY1eldTUDNWS2c9PSIsInZhbHVlIjoiOXVRTUVuVTNTVm12T2d4QnBEQkpOd0FqTEtsdTdGelpIV2txRlpXOVpcL1ZzTTZwNHdkbit5NnB0eTZ3WGhlazRGREFocURyM3FMNzBKRERsMmJGdnpRPT0iLCJtYWMiOiI2MmM4Y2JiYWQ5Mjk0NjMzYjZlMjExMDJkOGJlYzE2ZWNmYTZiOTJjYzIwMjA1YjRkMzNmYzZhZDUyNzI0ZGFmIn0=',
	panel: '/',
	api,
	apiOff: api + 'offline/',
	gtmID: 'GTM-5HRQXZS',
	productID: productID,
	userID: userID,
};
